import { InterviewType } from './interview.dto';
import { SchedulerConfigDto, SchedulerConfigListDto, SchedulerType } from './scheduler-config.dto';

export type SchedulerConfigViewModel = {
  id: string;
  slug: string;
  interviewType: InterviewType;
  name: string;
  location: string | null;
};

export type SchedulerConfigListViewModel = {
  [InterviewType.Online]: { address: string | null; duration: number };
  [InterviewType.InPerson]: { address: string | null; duration: number };
  [InterviewType.Call]: { address: string | null; duration: number };
};

export const toSchedulerConfigViewModel = (dto: SchedulerConfigDto): SchedulerConfigViewModel => {
  return {
    id: dto.id,
    slug: dto.slug,
    interviewType: getInterviewType(dto.scheduler_type),
    name: dto.name,
    location: dto.location,
  };
};

export const toSchedulerConfigListViewModel = (dto: SchedulerConfigListDto): SchedulerConfigListViewModel => {
  const result: SchedulerConfigListViewModel = {
    [InterviewType.Online]: { address: null, duration: 0 },
    [InterviewType.InPerson]: { address: null, duration: 0 },
    [InterviewType.Call]: { address: null, duration: 0 },
  };

  dto.forEach((item) => {
    result[getInterviewType(item.scheduler_type)] = { address: item.meeting_address, duration: item.meeting_duration };
  });

  return result;
};

export const getInterviewType = (schedulerType: SchedulerType): InterviewType => {
  switch (schedulerType) {
    case 'videocall':
      return InterviewType.Online;
    case 'physical_location':
      return InterviewType.InPerson;
    case 'phone_call':
      return InterviewType.Call;
  }
};

export const getSchedulerType = (interviewType: InterviewType): SchedulerType => {
  switch (interviewType) {
    case InterviewType.Online:
      return 'videocall';
    case InterviewType.InPerson:
      return 'physical_location';
    case InterviewType.Call:
      return 'phone_call';
  }
};
